import React from "react";
import styled from "styled-components";
import {Tooltip} from "antd";
import {logAction} from "../../logging/logEvent";
import {isUnrestricted} from "./restrictions";

const RedContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background: #BD2D2D;
    border-radius: 4px;
`;

const WhiteR = styled.span`
    font-weight: bold;
    font-size: 14px;
    text-align: right;
    width: 10px;
    line-height: 20px;
    height: 20px;
    color: #FFFFFF;
`;

export const RestrictionIcon = ({className, idea}) => {
    if (isUnrestricted(idea)) {
        return null;
    }

    const restrictionCodes = idea.restrictionCodes.join();
    const onMouseEnter = () => {
        logAction({
            type: "RESTRICT_ICON_HOVER",
            ideaId: idea.ideaId,
            restrictionCodes: restrictionCodes,
        });
    };
    return <Tooltip title={restrictionCodes} mouseLeaveDelay={0} onMouseEnter={onMouseEnter}>
        <RedContainer className={className}>
            <WhiteR>R</WhiteR>
        </RedContainer>
    </Tooltip>;
};